// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"MetadataVideoOverlay\"] {\n  background: #0008;\n  padding: 8px 15px;\n  font-size: 14px;\n  color: #eee;\n  max-width: 500px;\n  transform: translateX(-50%);\n  border: 1px solid transparent;\n}\ntextarea[name=\"MetadataVideoOverlay\"] {\n  border: 1px solid #eee;\n  transform: translateX(-50%) translateY(3px);\n}", ""]);
// Exports
module.exports = exports;
